import { DropDownItemCombinedProps } from './types';
import styles from './DropDownItem.module.scss';

const usePresenter = (props: DropDownItemCombinedProps): DropDownItemCombinedProps => {
  // MANUAL OVERRIDE
  return {
    ...props,
    text: {
      ...props.text,  
      classes: {
        ...props.text?.classes,
        value: styles.dropDownItemText,  
      }, 
    },
  };
};

export default usePresenter;
